import React, { useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const savePdf = (data, name) => {
  const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Dossier PDF delle elaborazioni: di lavoro (selezione libera) o per il proprietario (solo condivise).
export const PaDossierPanel = ({ caseId, items, selected }) => {
  const [busy, setBusy] = useState(null);
  const chosen = items.filter((i) => selected.includes(i.analysis_id));
  const shared = chosen.filter((i) => i.shared);
  const run = async (mode, list) => {
    setBusy(mode);
    try {
      const r = await api.post(`/v2/pa/cases/${encodeURIComponent(caseId)}/analyses/dossier`,
        { mode, analysis_ids: list.map((i) => i.analysis_id) }, { responseType: "blob" });
      savePdf(r.data, `dossier-pa-${mode === "work" ? "lavoro" : "proprietario"}.pdf`);
    } catch { toast.error("Generazione del dossier non riuscita"); }
    finally { setBusy(null); }
  };
  return (
    <div className="rounded-xl border border-dashed border-gray-300 p-4 space-y-3" data-testid="pa-dossier-panel">
      <p className="text-sm font-bold text-[#0A0A0A]">Dossier professionale</p>
      <p className="text-xs text-gray-500">
        Seleziona le elaborazioni con la casella accanto al titolo. Il dossier per il proprietario include solo quelle già condivise ({shared.length} su {chosen.length} selezionate), senza appunti interni.
      </p>
      <div className="flex flex-wrap gap-2">
        <button disabled={!!busy || !chosen.length} onClick={() => run("work", chosen)}
          className="vg-btn-secondary flex items-center gap-1 px-3 py-1.5 text-xs" data-testid="pa-dossier-work-btn">
          <FileDown size={13} /> {busy === "work" ? "Generazione…" : "Dossier di lavoro (PDF)"}
        </button>
        <button disabled={!!busy || !shared.length} onClick={() => run("owner", shared)}
          className="vg-btn-primary flex items-center gap-1 px-3 py-1.5 text-xs" data-testid="pa-dossier-owner-btn">
          <FileDown size={13} /> {busy === "owner" ? "Generazione…" : "Dossier per il proprietario (PDF)"}
        </button>
      </div>
    </div>
  );
};
